<template>
	<div class="view view--main main">
		<SiteHeader />
		<RouterView name="Content" />
		<SiteFooter />
	</div>
</template>

<script>
import { Smooth } from '@/lib/utils/smoothscroll'

import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
	name: 'ViewMain',
	components: {
		SiteHeader,
		SiteFooter,
	},
	mounted() {
		const smooth = Smooth.getInstance()
		smooth.init()
		smooth.enable()
	},
}
</script>

<style scoped lang="scss">
</style>
